import { render, staticRenderFns } from "./PlaceTab.vue?vue&type=template&id=55575e2c&"
import script from "./PlaceTab.vue?vue&type=script&lang=js&"
export * from "./PlaceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55575e2c')) {
      api.createRecord('55575e2c', component.options)
    } else {
      api.reload('55575e2c', component.options)
    }
    module.hot.accept("./PlaceTab.vue?vue&type=template&id=55575e2c&", function () {
      api.rerender('55575e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/PlaceTab.vue"
export default component.exports